export default "__VITE_ASSET__e90bfb44__"